/* @flow @format */

import { type ContextRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, ButtonIcon, Footer, Page, PageContainer, Panel, genRuby } from '@sonyged/ext-proc';
import qs from 'qs';

import type { StoreState } from '../../../redux/types';
import { contest, isReloadNeeded } from '../../../redux/selector';
import AppContext from '../../../AppContext';
import IntroModal from './IntroModal';
import TitleModal from '../../common/TitleModal';
import api from '../../../graphql/api';

type OwnProps = {|
  ...ContextRouter,
|};

type Props = {
  ...OwnProps,
  courseContentUid: ?string,
  reloadNeeded: boolean,
};

type State = {|
  introModal: boolean,
  titleModal: boolean,
|};

class PizzaFieldPage extends React.Component<Props, State> {
  static contextType = AppContext;

  constructor(props: Props) {
    super(props);

    if (props.reloadNeeded) location.reload();

    this.state = {
      introModal: this._getIntroFromQuery(props),
      titleModal: false,
    };
  }

  componentDidMount() {
    this.context.soundController.bgmPlay('proc_field02', true);

    // If browser reload this page or access to this page directly,
    // The parent dom is NOT rendered and the IntroModal try to refer to it and failed.
    // This code assures that the parent dom is rendered once.
    requestAnimationFrame(() => {
      this.forceUpdate();
    });
  }

  render() {
    const { introModal, titleModal } = this.state;
    if (introModal) {
      return (
        <div id="proc-pizza-fields-root-page" className="pizza">
          <IntroModal title="おすすめの ピザを つくろう" onNextClick={this._onIntroModalClose.bind(this)} />
        </div>
      );
    }

    if (titleModal) {
      return (
        <div id="proc-pizza-fields-root-page" className="pizza">
          <TitleModal
            title="フィールド"
            subTitle="おすすめの ピザを つくろう"
            rootNodeId="proc-pizza-fields-root-page"
            onNext={this._onNext.bind(this)}
          />
        </div>
      );
    }

    const { courseContentUid } = this.props;

    if (!courseContentUid) throw new Error('Unknown uid');

    return (
      <div
        id="proc-pizza-fields-root-page"
        className="proc-pizza-fields-top-page pizza course-top-page-template tertiary100-bg-color"
      >
        <Page.normal menu={false}>
          <PageContainer.normal>
            <Panel.vertical fullHeight={true}>
              <div className="course-top-page-content">
                <div className="title-container">
                  <div className="sub-title proc-small-font secondary100-color">フィールド</div>
                  <div className="title proc-huge-font gray100-color">おすすめの ピザを つくろう</div>
                </div>
                <div className="secondary20-border-color proc-border" />
                <div className="desc proc-medium-font gray100-color">
                  {genRuby('5[組|くみ]の おきゃくさんに ピザを 出して、もらう お金を きそうよ。')}
                </div>
                <div className="links-container">
                  <Link to="/pizza/fields/research" className="proc-button proc-button--normal">
                    <span className="icon-proc-pizza-research">
                      <span className="path1 icon-proc-path" />
                      <span className="path2 icon-proc-path" />
                      <span className="path3 icon-proc-path" />
                    </span>
                    しらべる
                  </Link>
                  <Link to="/pizza/fields/rank" className="proc-button proc-button--normal">
                    <span className="icon-proc-pizza-ranking">
                      <span className="path1 icon-proc-path" />
                      <span className="path2 icon-proc-path" />
                      <span className="path3 icon-proc-path" />
                      <span className="path4 icon-proc-path" />
                      <span className="path5 icon-proc-path" />
                    </span>
                    ランキング
                  </Link>
                </div>
                <img className="image" src="../../images/pages/pizza/img_pizza_field@2x.png" />
              </div>
              <Footer.nav
                className={'inner'}
                navItem={
                  <Link to="/pizza">
                    <Button.normal>
                      <ButtonIcon.back />
                    </Button.normal>
                  </Link>
                }
              >
                <Button.attention
                  className="next"
                  onClick={() => {
                    api.checkoutActivity({ courseContentUid }).then(() => {
                      this._onStartClick();
                    });
                  }}
                >
                  はじめる
                </Button.attention>
              </Footer.nav>
            </Panel.vertical>
          </PageContainer.normal>
        </Page.normal>
      </div>
    );
  }

  _onNext() {
    this.props.history.push('/pizza/fields/challenge');
  }

  _onStartCancel() {
    this.setState({ titleModal: false });
  }

  _onIntroModalClose() {
    this.setState({ introModal: false });
  }

  _onStartClick() {
    this.setState({ titleModal: true });
  }

  _getIntroFromQuery(props: Props) {
    const params = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    if (params['skip_intro']) {
      return false;
    }
    return true;
  }
}

PizzaFieldPage.propTypes = {
  history: PropTypes.object,
};

const mapStateToProps = (state: StoreState) => ({
  courseContentUid: contest.pizza.fieldUid(state),
  reloadNeeded: isReloadNeeded(state),
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, null)(PizzaFieldPage);
